// extracted by mini-css-extract-plugin
export default {"main":"AppDataForm_main__pdphc","main-btn":"AppDataForm_main-btn__b7LA0"};